import { isEmptyObject } from "../utils/is-empty-object";
import {isInteger} from "../utils/is-integer";

const getArrayLabels = (labelData = {}, isError = false) => {
  const labels = Object.values(labelData)
  .map((label) => {
    return {
      title: label.title || ``,
      background: label.background || ``,
      isError: false,
    };
  });

  if (isError) {
    labels.push({
      title: `*`,
      background: `#ff8`,
      isError: true,
    });
  }

  return labels;
};

const getArrayComments = (commentsData = {}) => {
  return Object.values(commentsData).map((comment) => {
    return comment;
  });
};

const getArrayImages = (imagesData = {}) => {
  return Object.values(imagesData).map((image) => {
    return image;
  });
};

const getArrayProperties = (propsData = {}) => {
  return Object.values(propsData).map((props) => {
    return {
      title: props.title,
      value: props.value,
    };
  });
};


export const getProductData = (data) => {
  return {
    itemId: data.item_id,
    title: data.item_name || ``,
    link: data.item_link || ``,
    imgSrc: data.item_image || ``,
    isActive: data.item_act,
    countCart: +data.item_cart, // удалить
    cartCount: +data.item_cart,
    count: +data.item_count,
    oldPrice: isInteger(+data.item_price_old) ? +data.item_price_old : ``,
    oldPriceSum: isInteger(+data.item_sum_old) ? +data.item_sum_old : ``,
    price: isInteger(+data.item_price) ? +data.item_price : ``,
    priceSum: isInteger(+data.item_sum) ? +data.item_sum : ``,
    isError: data.item_error,
    labels: getArrayLabels(data.item_labels, data.item_error) || [],
    rating: +data.item_rating || 0,
    comments: getArrayComments(data.item_comments) || [],
    commentCount: +data.item_comment_count || 0,
    deliveryDate: data.item_date || ``,
    deliveryText: data.item_date_button || ``,
    deliveryNote: data.item_date_note || ``,
    isFavorite: data.item_favorite || false,
    images: getArrayImages(data.item_images) || [],
    properties: getArrayProperties(data.item_prop) || [],
    stockCount: data.item_store,
    options: data.options,
    gifts: data.gifts,
  };
};
